/**
 * HomepageSolutions Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders HomepageSolutions Block
 */
import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { SVBTypography } from '@svb/svb-react-components';
import Loading from '@svb/api-loading-component/dist/components/index';
// import { Utils } from '@svb/api-content-component';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { getFileContent } from '../../helpers/utilityFunctions';
import { SVBCard, SVBButton } from '@svb/svb-react-components';
import { slugCreator } from '../../core/useStore';

/**
 * HomepageSolutions
 * @param content: url of the HomepageIntegratedSolutions content
 * @param backgroundImg: url for background image of this section
 * @returns HomepageSolutions block
 */

const HomepageSolutions = ({ datatestid, testMockContent, content, backgroundImg }) => {
  const [loading, setLoading] = useState(true);
  // const token = localStorage.getItem('token');
  const { regenTokenandBrowse } = browseAPIhandler();
  const getSolutionContent = datatestid
    ? testMockContent
    : getFileContent(`${content}`, regenTokenandBrowse);
  useEffect(() => {
    if (getSolutionContent.type === 'success') {
      setLoading(false);
    }
  }, [getSolutionContent.response]);

  if (loading) {
    return <Loading />;
  }

  // overrides HomepageSolutionsSection tag from markdown and renders solution section wrapper
  const HomepageSolutionsSection = ({ children }) => (
    <div className='cards row justify-content-between'>{children}</div>
  );

  // overrides h6 tag from markdown and renders explore heading with link
  const Explore = ({ children }) => {
    const child = children[0];
    const title = child.props.children[0] || 'title';
    const btnLink = child?.props?.href || '/home';
    return (
      <>
        <div className='text-end' data-testid='explore-solutions'>
          <SVBButton
            // extraClasses='m-1'
            text={title}
            size='large'
            style='primary'
            state='default'
            type='text'
            icon='right-arrow'
            iconSide='right'
            onClick={() => (window.location.href = btnLink)}
          />
        </div>
      </>
    );
  };
  const SectionHeader = ({ children }) => (
    <>
      <SVBTypography type='heading-large' variant='header-2'>
        {children}
      </SVBTypography>
      <div className='homepage_hero__Subseparation'></div>
    </>
  );
  const HompeageSolutionsCard = ({ link, cardIcon, title, description, buttonLabel }) => {
    // const footerElement = <a href={link} target="_blank">{buttonLabel}</a>;
    const cardTestid = slugCreator('card-' + title);
    const learnMoreTestid = slugCreator(buttonLabel + '-' + link);
    const cardOptions = {
      cardBootstrapImage: true,
    };
    const learnMoreLabel = () => (
      <span className='learn-more-label'>
        {buttonLabel}
        <i className='fa-solid fa-arrow-right right-arrow-icon' />
      </span>
    );
    return (
      <div className='col-md-4 col-sm-12 align-item-stretch d-flex mb-4'>
        <SVBCard
          buttonLabel={learnMoreLabel()}
          link={link}
          cardIcon={cardIcon}
          description={description}
          title={title}
          cardOptions={cardOptions}
          lazyLoading={true}
          datatestid={{ card: cardTestid, learnMore: learnMoreTestid }}
        />
      </div>
    );
  };
  const bg_img = backgroundImg
    ? {
        backgroundImage: `linear-gradient(90.26deg, rgba(0, 0, 0, 0.56) 37.16%, rgba(0, 0, 0, 0) 67.26%), url(${backgroundImg})`,
      }
    : {};

  return (
    <section
      data-testid={datatestid}
      id='homepage-solutions'
      className='solution-section'
      style={bg_img}
    >
      <div className='container svb-container-fixed col-md-9 col-sm-12'>
        <Markdown
          options={{
            overrides: {
              h2: {
                component: SectionHeader,
              },
              h6: {
                component: ({ children }) => Explore({ children }),
              },
              HomepageSolutionsSection: {
                component: HomepageSolutionsSection,
              },
              Card: {
                component: HompeageSolutionsCard,
              },
            },
          }}
        >
          {getSolutionContent.response}
        </Markdown>
      </div>
    </section>
  );
};
export default HomepageSolutions;
